import { request } from "../core/request";

export function del(uri: string, options?: RequestInit) {
  if (!options) {
    options = {};
  }
  options.method = "DELETE";
  return request(uri, options);
}
